import { Recurso } from "lib.common/dist/CleanArch";
import { ConciliacionDtSource } from "../../bussines/dataSources/ConciliacionDtSource";
import { AbonoPasarela } from "../../bussines/entities/AbonoPasarela";
import { ConciliacionRepository } from "../../bussines/repositories/ConciliacionRepository";
import { GetSomeConciliacionParams } from "../../utils/params/GetSomeConciliacionParams";
import { AbonoPasarelaModel } from "../models/AbonoPasarelaModel";
import { ErrDevValidacion } from "lib.common/dist/errorHandler";

export class ConciliacionRepositoryImpl implements ConciliacionRepository<AbonoPasarela> {
    private dataSource: ConciliacionDtSource;
    constructor(dataSource: ConciliacionDtSource) {
        this.dataSource = dataSource;
    }
    async getSomeConciliacion(input: GetSomeConciliacionParams): Promise<Recurso<AbonoPasarela[]>> {
        try {
            const result = await this.dataSource.getSomeConciliacion(input);
            if (result.isSuccess()) {
                return Recurso.fromData<AbonoPasarela[]>(
                    result.data!.map(AbonoPasarelaModel.deserialize)
                );
            }
            return Recurso.fromError<AbonoPasarela[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<AbonoPasarela[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }
}